import axios from "../../api/axios";
import { useAuth } from ".";
import { useMutation } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import { handleFormErrors } from "../../utils/helpers";

export const useAuthMutation = () => {
  const { login } = useAuth();
  const loginMutation = useMutation({
    mutationFn: login,
    mutationKey: "login",
  });

  return {
    loginMutation,
  };
};
export const useResetPasswordMutation = (setError) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return useMutation({
    mutationFn: (payload) => axios.post("reset-password", payload),
    mutationKey: "resetPassword",
    onSuccess: () => {
      navigate("/login");
    },
    onError: (err) => {
      handleFormErrors(err, setError, t, "PASSWORD_RESET_FAILED");
    },
  });
};
export const useForgetPasswordMutation = () => {
  const { t } = useTranslation();

  return useMutation({
    mutationFn: (payload) => axios.post("forgot-password", payload),
    mutationKey: "forgetPassword",
    onSuccess: (data, variables, context) => {
      // Call the onSuccess callback if provided
      if (context?.onSuccess) {
        context.onSuccess(data, variables, context);
      } else {
        // Default behavior - show toast
        toast.success(t("FORGOT_PASSWORD_SUCCESSFULLY"));
      }
    },
    onError: (err, variables, context) => {
      // Call the onError callback if provided
      if (context?.onError) {
        context.onError(err, variables, context);
      } else {
        // Default behavior - show toast
        toast.error(
          err?.response?.data?.message ||
            err?.message ||
            t("FORGOT_PASSWORD_FAILED")
        );
      }
    },
  });
};
